import React from 'react'
import CWMain from '../components/covid-workplace/CWMain'
import CWTests from '../components/covid-workplace/CWTests'
import CWWeeklyWorkplace from '../components/covid-workplace/CWWeeklyWorkplace'
import CWFaq from '../components/covid-workplace/CWFaq'
import TopHeader from '../layout/TopHeader'
import MainHeader from '../layout/MainHeader'
import Footer from '../layout/Footer'
import CopyRight from '../layout/CopyRight'
import MainResHeader from '../layout/MainResHeader'
import { useEffect } from 'react'
import { Helmet, HelmetProvider } from 'react-helmet-async'

const CovidWorkplacePage = () => {

  useEffect(()=>{
    window.scrollTo(0,0)
  },[])

  return (
    <div style={{ overflow:'hidden'}}>

    <HelmetProvider>
      <Helmet prioritizeSeoTags>
      <title>Workplace Covid-19 Test Services in Chicago IL | United Lab Care</title>
      <meta name="description" content="Keep your workplace safe with Covid testing in Chicago. We provides reliable testing services for employees. Schedule your appointment today." />
	<link rel="canonical" href="https://unitedlabcare.com/workplace-covid-19-test-in-chicago/" />
	<meta property="og:locale" content="en_US" />
	<meta property="og:type" content="article" />
	<meta property="og:title" content="Workplace Covid-19 Test Services in Chicago IL | United Lab Care" />
	<meta property="og:description" content="Keep your workplace safe with Covid testing in Chicago. We provides reliable testing services for employees. Schedule your appointment today." />
	<meta property="og:url" content="https://unitedlabcare.com/workplace-covid-19-test-in-chicago/" />
	<meta property="og:site_name" content="United Lab Care" />
	<meta property="article:modified_time" content="2023-03-29T13:11:31+00:00" />
	<meta property="og:image" content="https://unitedlabcare.com/wp-content/uploads/2023/03/Workplace-Covid-Testing-img1-v1.webp" />
	<meta name="twitter:card" content="summary_large_image" />
	<meta name="twitter:label1" content="Est. reading time" />
	<meta name="twitter:data1" content="2 minutes" />
      </Helmet>
    </HelmetProvider>

        <TopHeader/>
        {/* <MainHeader/> */}
        <MainResHeader/>
        
        <CWMain/>
        <CWTests/>
        <CWWeeklyWorkplace/>
        <CWFaq/>

        <Footer/>
        <CopyRight/>
    </div>
  )
}

export default CovidWorkplacePage